/******************************************************************************
 *
 * useWorkDetails
 *
 * Loads all runtime information required by Work Details Page.
 *
 * This hook becomes the single source of truth for Work Execution.
 *
 ******************************************************************************/

import { useState, useEffect, useCallback } from "react";

import wmsWorkService from "../../services/wmsWorkService";

export default function useWorkDetails(workId) {

    const [loading, setLoading] = useState(true);

    const [work, setWork] = useState(null);

    const [assignments, setAssignments] = useState([]);

    const [watchers, setWatchers] = useState([]);

    const [checklists, setChecklists] = useState([]);

    const [workItems, setWorkItems] = useState([]);
    const [selectedWorkItem, setSelectedWorkItem] = useState(null);

    const [timeline, setTimeline] = useState([]);

    const [documents, setDocuments] = useState([]);

    const [comments, setComments] = useState([]);


    const refresh = useCallback(async () => {

        try {

            setLoading(true);

            const workResult =
                await wmsWorkService.getWork(workId);

            setWork(workResult);


            const assignmentResult =
                await wmsWorkService.getAssignments(workId);

            setAssignments(assignmentResult || []);


            const watcherResult =
                await wmsWorkService.getWatchers(workId);

            setWatchers(watcherResult || []);

            /*
             * Future APIs
             *
             * Uncomment once APIs are available.
             */

            // setChecklists(await wmsWorkService.getChecklists(workId));

            // setWorkItems(await wmsWorkService.getWorkItems(workId));
            const items =
            await wmsWorkService.getWorkItems(workId);

            setWorkItems(items);

            if (
                items &&
                items.length > 0
            ) {
                setSelectedWorkItem(items[0]);
            }

            // setTimeline(await wmsWorkService.getTimeline(workId));

            // setDocuments(await wmsWorkService.getDocuments(workId));

            // setComments(await wmsWorkService.getComments(workId));

        }

        finally {

            setLoading(false);

        }

    }, [workId]);


    useEffect(() => {

        if (workId) {

            refresh();

        }

    }, [refresh, workId]);

    useEffect(() => {

        async function loadChecklist() {

            if (!selectedWorkItem) {

                setChecklists([]);

                return;

            }

            try {

                const data =
                    await wmsWorkService.getWorkItemChecklists(
                        selectedWorkItem.id
                    );
                    console.log(
                        "Runtime Checklists JSON:",
                        JSON.stringify(data, null, 2)
                    );

                console.log("Selected Work Item:", selectedWorkItem);

                console.log("Runtime Checklists:", data);

                setChecklists(data || []);
            }

            catch (err) {

                console.error(err);

                setChecklists([]);

            }

        }

        loadChecklist();

    }, [selectedWorkItem]);

    return {

        loading,

        refresh,

        work,

        assignments,

        watchers,

        checklists,

        workItems,

        timeline,
        selectedWorkItem,
        setSelectedWorkItem,

        documents,

        comments

    };

}